/**
 * It takes a form object and a palette object and returns a React component that renders the form
 */
import React, { Component } from "react"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import FieldTypes from "../Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import fieldMap from "./Fields/FieldMap"
import { Button, OverlayTrigger } from "react-bootstrap"
import stateMutator from "../Utils/StateMutator"
import buildTemplate from "../Utils/TemplateBuilder/BuildTemplate"
import ProgressRing from "../Utils/ProgressRing"
import formStatus from "../Utils/FormStatus"
import store from "src/store/store"
import paletteEngine from "../Utils/paletteEngine"
import NotificationTypes from "src/utilities/Notifications/Types/NotificationTypes"
import notificationStore from "src/utilities/Notifications/notificationStore"
import dayjs from "dayjs"
import "./DynamicForm.css"

interface Props {
    form: DynamicFormTypes
    addOrRemoveColumn: Function
    submit: Function
    palette: Array<DynamicFormPaletteTypes>
    helper?: any
    notificationToMarkDateRead?: NotificationTypes
    readOnly?: boolean
}

interface State {
    form: DynamicFormTypes
    template: Array<Array<FieldTypes>> | []
    target: { row: number, col: number, key: string }
}

class DynamicForm extends Component<Props, State> {

    state = {
        form: this.props.form,
        template: [[]],
        target: { row: -1, col: -1, key: "" }
    }

    componentDidMount() {
        store.dispatch({ type: "RESET_DYNAMIC_FORM_PALETTE", payload: null })
        this.manageState([{ key: "template", value: buildTemplate(this.props.form) }])
        if (this.props.notificationToMarkDateRead && !this.props.notificationToMarkDateRead.dateReadUtc) {
            let notification = this.props.notificationToMarkDateRead
            notification.dateReadUtc = dayjs.utc().format(notificationStore.timeFormat)
            notificationStore.addOrUpdateNotification([notification])
        }
    }

    /* A function that is used to update the state. It is used to prevent the state from being updated in
    an uncontrolled manner. */
    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(stateMutator.mutate(this.state, keys))
    }

    handleChange = (event: { target: { value: any } }) => {
        if (!this.props.readOnly) {
            const input = event.target.value
            const target = this.state.target
            let template = this.state.template
            //@ts-ignore
            template[target.row][target.col][target.key] = input === "" ? null : input
            this.manageState([{ key: "template", value: template }])
        }
    }

    render() {

        const state = this.state
        const props = this.props
        const palette = props.palette
        const status = formStatus.getFormStatus(state.template, palette)

        // console.log("df_DynamicForm props", props)
        // console.log("df_DynamicForm state", state)

        return (
            <div className="DynamicForm" style={{ backgroundColor: `${paletteEngine.getPaletteColor("formBackgroundColor")}` }}>
                {state.template.map((row, i: number) =>
                    <div className="DynamicFormRow" key={`dynamic-form-row-${i}`}>
                        {row.map((col: FieldTypes, j: number) =>
                            <div className="DynamicFormColumn" key={`dynamic-form-col-${j}`}>
                                {fieldMap.buildField(col.Type, i, j, state.template, props.palette, this.handleChange, this.manageState, props.addOrRemoveColumn, false, props.readOnly)}
                            </div>)}
                    </div>)}
                {!props.readOnly && <div className="DynamicFormFooter">
                    <div className="DynamicFormFooterLeft">
                        {status.progress > -1 && <div className="DynamicFormFooterProgressRing">
                            <ProgressRing progress={status.progress}
                                pathColor={paletteEngine.getPaletteColor("progressRingPathColor")}
                                trailColor={paletteEngine.getPaletteColor("progressRingTrailColor")}
                                textColor={paletteEngine.getPaletteColor("progressRingTextColor")}
                            />
                        </div>}
                    </div>
                    <div className="DynamicFormFooterRight">
                        {!status.canSubmit && <OverlayTrigger placement="top" overlay={status.popover}>
                            <span style={{ color: `${paletteEngine.getPaletteColor("missingFieldsIconColor")}` }} className="material-icons DynamicFormFooterMissingFieldsInfo">error</span>
                        </OverlayTrigger>}
                        {!props.readOnly && <Button
                            id="dynamic-form-submit-btn"
                            style={{ backgroundColor: `${paletteEngine.getPaletteColor("submitBtnBackgroundColor")}`, color: `${paletteEngine.getPaletteColor("submitBtnTextColor")}` }}
                            disabled={!status.canSubmit}
                            onClick={props.submit ? () => props.submit(state.form, state.template, props.helper ? props.helper : null) : () => null}>
                            Submit
                        </Button>}
                    </div>
                </div>}
            </div>
        )
    }
}

export default DynamicForm